import Logo from '../assets/logo.png';

//Importing Navbar Assets
import icon1 from '../assets/navbar/icon1.svg'
import icon2 from '../assets/navbar/icon2.svg'

//Importing Contact Us Assets
import cartography from '../assets/contactUs/cartography.png'

//Importing 'What we do' menu icons
import ProductIcon from '../assets/navbar/products.png';
import PlatformIcon from '../assets/navbar/products.png';
import IndustriesIcon from '../assets/navbar/industries.png';
import ServicesIcon from '../assets/navbar/services.png';

//Importing Product Page Assets
import diffIcon1 from '../assets/differentiators/1.svg';
import diffIcon2 from '../assets/differentiators/2.svg';
import diffIcon3 from '../assets/differentiators/3.svg';
import diffIcon4 from '../assets/differentiators/4.svg';
import featureIcon1 from '../assets/products/1.svg';
import featureIcon2 from '../assets/products/2.svg';
import featureIcon3 from '../assets/products/3.svg';
import pCoverImage1 from '../assets/products/Know_your_customers_business.png';
import pCoverImage2 from '../assets/products/List_Management.png';
import pCoverImage3 from '../assets/products/Customer_due_digilence.png';
import pCoverImage4 from '../assets/products/Enhanced_due_digilence.png';
import pCoverImage5 from '../assets/products/Anti-Money_Laundering.png';
import pCoverImage6 from '../assets/products/Enhanced_anti-money_laundering.png';

//Importing AboutUs Page Assets
import aIcon1 from '../assets/aboutUs/Group1.svg';
import aIcon2 from '../assets/aboutUs/Group2.svg';
import aIcon3 from '../assets/aboutUs/Group3.svg';
import aCoverImage from '../assets/aboutUs/cover1.jpg';

//Importing Our Service Page Assets
import sCoverImage1 from '../assets/services/Professional_services.png';
import sCoverImage2 from '../assets/services/Enterprise_consulting.png';
import sCoverImage3 from '../assets/services/Training_services.png';
import sCoverImage4 from '../assets/services/Support_&_Maintenance.png';
import WhereQberaaCanHelp from './../pages/Home/WhereQberaaCanHelp/index';


export const navMenuData = {
    logo: Logo,
    list: [
        { title: 'About Us', link: '/aboutUs',
            data: {
                cols: [
                ], 
            }
        },
        { title: 'What we do', link: '#', 
            data: {
                cols: [
                    {title: 'Products',
                    icon: ProductIcon, 
                    items: [
                        { linkName: 'Know your customers/business', link: '/products/0'},
                        { linkName: 'List Management', link: '/products/1'},
                        { linkName: 'Customer due diligence', link: '/products/2'},
                        { linkName: 'Enhanced due diligence', link: '/products/3'},
                        { linkName: 'Anti-Money Laundering', link: '/products/4'},
                        { linkName: 'Enhanced anti-Money Laundering', link: '/products/5'},
                    ]},
                    {title: 'Services',
                    icon: ServicesIcon,
                    items: [
                        {linkName: 'Professional Services', link: '/services/0'},
                        {linkName: 'Enterprise consulting', link: '/services/1'},
                        {linkName: 'Training services', link: '/services/2'},
                        {linkName: 'Support & Maintenance', link: '/services/3'},
                    ]},
                    {title: 'Platform',
                    icon: PlatformIcon,
                    items: [
                        {linkName: 'Digital Platform', link: '/platform/0'},
                    ]},
                    {title: 'Industries',
                    icon: IndustriesIcon,
                    items: [
                        {linkName: 'Banking', link: '/industries/0'},
                    ]},
                ], 
            }
        },
        { title: 'Get In Touch', link: '#', 
            data: {
                cols: [
                ],
                content: [
                    {   
                        contactInfo: [
                            {icon: icon1, text: 'info@qberaa.com'},
                            {icon: icon2, text: '+31 (0)6 44 29 51 15'},
                        ],
                        title: 'title',
                        text: 'World Trade Center Amsterdam, Strawinskylaan 1, 1077 XW Amsterdam, Netherlands'
                    }
                ]
            }
        },
    ],
    mobileMenu: [
        {
            item: 'Home', link: '/home',
            children: []
        },
        {
            item: 'About Us', link: '/aboutUs',
            children: []
        }
        ,
        {
            item: 'What we do', link: '',
            children: [
                { item: 'Back', link: '', children: []},
                {item: 'Products', link: '',
                children: [
                    { item: 'Back', link: '', children: []},
                    { item: 'Know your customers/business', link: '/products/0', children: []},
                    { item: 'List Management', link: '/products/1', children: []},
                    { item: 'Customer due diligence', link: '/products/2', children: []},
                    { item: 'Enhanced due diligence', link: '/products/3', children: []},
                    { item: 'Anti-Money Laundering', link: '/products/4', children: []},
                    { item: 'Enhanced anti-Money Laundering', link: '/products/5', children: []},
                ]},
                {item: 'Services', link: '',
                children: [
                    { item: 'Back', link: '', children: []},
                    {item: 'Professional Services', link: '/services/0', children: []},
                    {item: 'Enterprise consulting', link: '/services/1', children: []},
                    {item: 'Training services', link: '/services/2', children: []},
                    {item: 'Support & Maintenance', link: '/services/3', children: []},
                ]}
            ]
        },
        {
            item: 'Get In Touch', link: '/GetinTouch',
            children: []
        }
    ]
}

export const homeData = {
    differentiator: {
        title: '',
        bgColor: '#0A2540',
        fontColor: 'white',
        items: [
            {
                id: Math.random(),
                title: '',
                icon: diffIcon1,
                text: 'Integrated process and workflow management for all modules',
                bgColor: '#0A2540',
                fontColor: 'white'
            },
            {
                id: Math.random(),
                title: '',
                icon: diffIcon2,
                text: 'Holistic view of all transactions and associated risks',
                bgColor: '#0A2540',
                fontColor: 'white'
            },
            {
                id: Math.random(),
                title: '',
                icon: diffIcon3,
                text: 'Predictive analysis based persona for each client',
                bgColor: '#0A2540',
                fontColor: 'white'
            },
            {
                id: Math.random(),
                title: '',
                icon: diffIcon4,
                text: 'Configurable Anti Money Laundering Scenarios across all product patterns',
                bgColor: '#0A2540',
                fontColor: 'white'
            },
        ]
    }
}

export const aboutUsData = {
    title: 'About Us',
    headerImage: aCoverImage,
    pageTitle: 'The Qberaa Team',
    content: "Qberaa is a fintech start-up established in 2020. We have an international team of 11 employees in the information technology industry. We are an amalgamation of Functional SMEs, Technology Architects, Solution Designers, Program & Operations manager and developers from Finance and retail domains. Bringing in a total cumulative experience of 160 man-years. Our idea for starting Qberaa (a fintech company) started in 2015. At that time the core team members of Qberaa were working for different financial institutions. We saw different kind of software products being used, but the customers were still facing pain with the use of these products. Qberaa resolves most of the pains customers in the financial industry are suffering from. Our Competitive Advantage is an end-to-end integrated solution for our product platform to minimize customers pain and at the same time maximize customers profit. Interested how we do that? Get in touch with us!",
    list: [
        {icon: aIcon1, text: '11 Team member strong'},
        {icon: aIcon2, text: 'Cumulative experience of 160 man-years'},
        {icon: aIcon3, text: 'Functional SMEs, Technology Architects, Solution Designers, Developers & Program  operations manager '},
    ]
}

export const contactUsData = {
    headerImage: cartography,
    email: 'info@qberaa.com',
    phoneNumber: '+31 (0)6 44 29 51 15'
}

export const uniqueOfferingData = {
    title: 'Unique offerings of ',
    cardItems: [
        {svgIcon: 'rightArrow', aligSvgTopOrBottom:'Top', aligSvgLeftorRight:'Left', text: 'An end-to-end solution for Financial crime detection and prevention', highlightText:'end-to-end solution'},        
        {svgIcon: 'timeIcon', aligSvgTopOrBottom:'Bottom', aligSvgLeftorRight:'Left', text: 'Digital realtime checks for faster customer onboarding', highlightText:'realtime checks'}, 
        {svgIcon: 'searchIcon', aligSvgTopOrBottom:'Bottom', aligSvgLeftorRight:'Right', text: 'Artificial Intelligence (AI) driven algorithms for predictive results', highlightText:'predictive results'},       
        {svgIcon: 'bondingIcon', aligSvgTopOrBottom:'Top', aligSvgLeftorRight:'Right', text: 'Multifactor machine learning based risk scoring for customers', highlightText:'Multifactor machine learning'}
    ]
}

export const financialCrimesData = {
    title: 'Financial Crimes Data',
    content: 'With an ever-increasing avenue for money laundering, the regulators have implemented more stringent regulation in place to prevent financial crime that financial institutions have to adhere.',
    stats: [
        {text: 'Amount of fine for the financial institution', data:'$11bn'},        
        {text: 'Amount of money laundered', data:'$800bn - $2tr'},        
        {text: '% of money laundered in terms of global GDP', data:'2 - 5%'},                
    ]
}

export const whereQberaaCanHelp = {
    title: 'Here is where Qberaa comes into picture ',
    content1: 'With Qberaa we will prevent such incidents for financial organizations ',
    content2: 'Our solution aims to solve all these problems and more; using best-in-breed technology solutions supported by Artificial Intelligence (AI) driven algorithms for predictive results'    
}

export const qberaaMain = {
    title: 'Best in class integrated solutions for financial crime',
    subTitle: 'Ensuring a safe future',
    content: 'Preventing Financial Economical crime (FEC) is key for ensuring a safe and sustainable future. Financial institutions have been hit with billions in global fines and penalties related to financial economical crime. Qberaa is making the best products for a cleaner money ensuring a safe future. We are not searching for good customers; we are working on successful relations to build a safer economy together.'    
}


export const contactUsInfo = {
    items:[
        { contact: 'info@qberaa.com', svgIcon: "email"},
        { contact: '+31 (0)6 44 29 51 15', svgIcon: "phone"}
    ]
   
}

export const whyBestinMarket = {
    title: 'Why Qberaa is the best in the Market?',
    content: 'The advancement in the Cloud technologies and API driven architecture has challenged the limitations of the current monolithic architecture driven AML products, which are currently in use in the Financial Institutions. Therefore, leveraging the advancement in the technologies to keep pace with the change in the regulatory Regime and moving ahead of Money launderers, Qberaa offers a lightweight Cloud based solutions, which not only helps reduce the Cost of Compliance but also significantly reduce the burden of the monitoring officers by significantly reducing the number of false positives and one stop shop for full audit trails of all the transactions. Qberaa offers a risk-based approach to monitor all complex transactions to meet the regulatory requirements of various regulatory authority such as FATF, FCA, FinCen and more.',
    differentiator: {
        title: '',
        bgColor: '#0A2540',
        fontColor: 'white',
        items: [
            {
                id: Math.random(),
                title: '',
                icon: diffIcon1,
                text: 'Integrated process and workflow management for all modules',
                bgColor: '#0A2540',
                fontColor: 'white'
            },
            {
                id: Math.random(),
                title: '',
                icon: diffIcon2,
                text: 'Holistic view of all transactions and associated risks',
                bgColor: '#0A2540',
                fontColor: 'white'
            },
            {
                id: Math.random(),
                title: '',
                icon: diffIcon3,
                text: 'Predictive analysis based persona for each client',
                bgColor: '#0A2540',
                fontColor: 'white'
            },
            {
                id: Math.random(),
                title: '',
                icon: diffIcon4,
                text: 'Configurable Anti Money Laundering Scenarios across all product patterns',
                bgColor: '#0A2540',
                fontColor: 'white'
            },
        ]
    }
}

export const productsData = [
    {
        title: 'Know your customers/business',
        headerImage: pCoverImage1,
        pageTitle: 'Features',
        features: [
            {title: 'Customer Screening ', icon: featureIcon1, text: 'We do name screening , Address screening along with new features and real time validations of addresses.'},
            {title: 'Work Flow Management', icon: featureIcon2, text: 'We help and improvise process with workflow for KYC'},
            {title: 'Risk Assessment Management', icon: featureIcon3, text: 'Assess and create risk profile and persona for each customer.'},
        ],
        differentiator: {
            title: 'Differentiators',
            bgColor: '#0A2540',
            fontColor: 'white',
            items: [
                {
                    id: Math.random(),
                    title: '',
                    icon: diffIcon1,
                    text: 'Automatic Data Capture',
                    bgColor: '#0A2540',
                    fontColor: 'white'
                },
                {
                    id: Math.random(),
                    title: '',
                    icon: diffIcon2,
                    text: 'Image and document validity processing',
                    bgColor: '#0A2540',
                    fontColor: 'white'
                },
                {
                    id: Math.random(),
                    title: '',
                    icon: diffIcon3,
                    text: 'Real Time Fraud Check',
                    bgColor: '#0A2540',
                    fontColor: 'white'
                },
                {
                    id: Math.random(),
                    title: '',
                    icon: diffIcon4,
                    text: 'Bio Metric Check',
                    bgColor: '#0A2540',
                    fontColor: 'white'
                },
            ]
        },
        content1: {
            title: 'Accelerator',
            list: [
                {text: 'One Stop Document & Fraud Check'},
                {text: 'Highly Configurable'},
                {text: 'Automated Third Party Data Validation'},
            ]
        }
    },
    {
        title: 'List Management',
        headerImage: pCoverImage2,
        pageTitle: 'Features',
        features: [
            {title: 'Integration', icon: featureIcon1, text: 'Integration with customer data with & internal data sources & external sources.'},
        ],
        differentiator: {
            title: 'Differentiators',
            bgColor: '#0A2540',
            fontColor: 'white',
            items: [
                {
                    id: Math.random(),
                    title: '',
                    icon: diffIcon1,
                    text: 'Realtime update of list',
                    bgColor: '#0A2540',
                    fontColor: 'white'
                },
                {
                    id: Math.random(),
                    title: '',
                    icon: diffIcon2,
                    text: 'Realtime update the impact of existing customer',
                    bgColor: '#0A2540',
                    fontColor: 'white'
                },
                {
                    id: Math.random(),
                    title: '',
                    icon: diffIcon3,
                    text: 'Integration with KYC / CDD / AML & other modules',
                    bgColor: '#0A2540',
                    fontColor: 'white'
                },
                {
                    id: Math.random(),
                    title: '',
                    icon: diffIcon4,
                    text: 'Micro-service based request and responses',
                    bgColor: '#0A2540',
                    fontColor: 'white'
                },
            ]
        },
        content1: {
            title: 'Accelerator',
            list: [
                {text: 'Web scrapping'},
                {text: 'Social media integration for sentiment analysis'},
                {text: 'Near real time integration'},
            ]
        }
    },
    {
        title: 'Customer due digilence',
        headerImage: pCoverImage3,
        pageTitle: 'Features',
        features: [
            {title: 'Integration', icon: featureIcon1, text: 'Integration with KYC / List / AML in real time'},
            {title: 'Risk Score', icon: featureIcon2, text: 'Update risk score based on due diligence'},
        ],
        differentiator: {
            title: 'Differentiators',
            bgColor: '#0A2540',
            fontColor: 'white',
            items: [
                {
                    id: Math.random(),
                    title: '',
                    icon: diffIcon1,
                    text: 'ML/ AI algorithms for customer ratings',
                    bgColor: '#0A2540',
                    fontColor: 'white'
                },
                {
                    id: Math.random(),
                    title: '',
                    icon: diffIcon2,
                    text: 'Update of Risk factor to KYC/ AML',
                    bgColor: '#0A2540',
                    fontColor: 'white'
                },
                {
                    id: Math.random(),
                    title: '',
                    icon: diffIcon3,
                    text: 'Trigger workflow-based change in Risk factor',
                    bgColor: '#0A2540',
                    fontColor: 'white'
                }
            ]
        },
        content1: {
            title: 'Accelerator',
            list: [
                {text: 'Near Realtime Risk Calculations'},
                {text: 'Enhanced due diligence in real time'},
                {text: 'Media Screening& web scrapping'},
            ]
        }
    },
    {
        title: 'Enhanced due digilence ',
        headerImage: pCoverImage4,
        pageTitle: 'Features',
        features: [
            {title: 'Screening of PEPs', icon: featureIcon1},
            {title: 'Private Banking Customers', icon: featureIcon2},
            {title: 'Corporates', icon: featureIcon3},
        ],
        differentiator: {
            title: 'Differentiators',
            bgColor: '#0A2540',
            fontColor: 'white',
            items: [
                {
                    id: Math.random(),
                    title: '',
                    icon: diffIcon1,
                    text: 'Enhanced due diligence in real time',
                    bgColor: '#0A2540',
                    fontColor: 'white'
                },
                {
                    id: Math.random(),
                    title: '',
                    icon: diffIcon2,
                    text: 'Real time Media Screening',
                    bgColor: '#0A2540',
                    fontColor: 'white'
                },
                {
                    id: Math.random(),
                    title: '',
                    icon: diffIcon3,
                    text: 'news searches',
                    bgColor: '#0A2540',
                    fontColor: 'white'
                },
            ]
        },
        content1: {
            title: 'Accelerator',
            list: [
                {text: 'Near Realtime updates '},
                {text: 'Bi-directional Triggers AML'},
                {text: 'LIST'},
            ]
        }
    },
    {
        title: 'Anti-Money Laundering',
        headerImage: pCoverImage5,
        pageTitle: 'Features',
        features: [
            {title: 'Scenarios', icon: featureIcon1, text: 'Traditional scenarios of FATF, Wolfsburg and others 27 Major scenarios and 70 Sub Scenarios'},
        ],
        differentiator: {
            title: 'Differentiators',
            bgColor: '#0A2540',
            fontColor: 'white',
            items: [
                {
                    id: Math.random(),
                    title: '',
                    icon: diffIcon1,
                    text: 'ML/AI algorithm',
                    bgColor: '#0A2540',
                    fontColor: 'white'
                },
                {
                    id: Math.random(),
                    title: '',
                    icon: diffIcon2,
                    text: 'End to End Visualization',
                    bgColor: '#0A2540',
                    fontColor: 'white'
                },
                {
                    id: Math.random(),
                    title: '',
                    icon: diffIcon3,
                    text: 'Robotic process for Alert Analytics',
                    bgColor: '#0A2540',
                    fontColor: 'white'
                },
                {
                    id: Math.random(),
                    title: '',
                    icon: diffIcon4,
                    text: 'Pro Active Pattern Detections',
                    bgColor: '#0A2540',
                    fontColor: 'white'
                },
            ]
        },
        content1: {
            title: 'Accelerator',
            list: [
                {text: 'Visual Context Creation for Analytics'},
                {text: 'Risk based Real Time Monitoring'},
                {text: 'AI Driven Segmentation and Cluster Analysis'},
            ]
        }
    },
    {
        title: 'Enhanced anti-money laundering',
        headerImage: pCoverImage6,
        pageTitle: 'Features',
        features: [
            {title: '', icon: featureIcon1, text: 'Additional Behavioral Scenarios'},
            {title: '', icon: featureIcon2, text: 'Capital Market & Insurance Scenarios'},
        ],
        differentiator: {
            title: 'Differentiators',
            bgColor: '#0A2540',
            fontColor: 'white',
            items: [
                {
                    id: Math.random(),
                    title: '',
                    icon: diffIcon1,
                    text: 'Linkage to Individual Risk Based scoring',
                    bgColor: '#0A2540',
                    fontColor: 'white'
                },
                {
                    id: Math.random(),
                    title: '',
                    icon: diffIcon2,
                    text: 'AI Driven Behavioral Analysis',
                    bgColor: '#0A2540',
                    fontColor: 'white'
                },
                {
                    id: Math.random(),
                    title: '',
                    icon: diffIcon3,
                    text: 'Robotic process for Alert Analytics',
                    bgColor: '#0A2540',
                    fontColor: 'white'
                },
                {
                    id: Math.random(),
                    title: '',
                    icon: diffIcon4,
                    text: 'Pro Active Pattern Detections',
                    bgColor: '#0A2540',
                    fontColor: 'white'
                },
            ]
        },
        content1: {
            title: 'Accelerator',
            list: [
                {text: 'Reusable APIs and data structure'},
                {text: 'Reusable Rule Engine & Statistical Model'},
                {text: 'AI Driven Segmentation and Cluster Analysis'},
            ]
        }
    }
]

export const servicesData = [
    {
        title: 'Professional services',
        headerImage: sCoverImage1,
        pageTitle: 'Our Service',
        content: "Qberaa professional services provides a first-class team of dedicated and highly talented professionals with decades of experience and deep expertise in implementing business-critical technology solutions."
    },
    {
        title: 'Enterprise consulting',
        headerImage: sCoverImage2,
        pageTitle: 'Our Service',
        content: "We provide management consulting specializing in IFS implementations, upgrades, and optimization. We leverage our expertise across many different ERP, Business Intelligence and Web Based solutions to help realize maximum value from enterprise software investments."
    },
    {
        title: 'Training services',
        headerImage: sCoverImage3,
        pageTitle: 'Our Service',
        content: "We provide innovative learning and development solutions, covering multiple areas and industries, tailored to meet your needs. Our courses are delivered in both face-to-face and eLearning environments, ensuring training objectives are achieved no matter where you are."
    },
    {
        title: 'Support & Maintenance',
        headerImage: sCoverImage4,
        pageTitle: 'Our Service',
        content: "Qberaa Smart shoring offers IT support and software maintenance services in a nearshoring and/or an offshoring model. We can take over the technical support, maintenance and development o/your existing application of any size and start to provide you with cost-effective real-time softwar/support, maintenance and development services."
    },
]

export const platformData = [
    {
        title: 'Digital Platform',
        headerImage: sCoverImage1,
        pageTitle: 'Platforms',
        content: "The current version of our product is fully digital and based on Azure platform. AWS and GCP versions of the platform are in our future roadmap."
    },
]

export const industriesData = [
    {
        title: 'Banking Industry',
        headerImage: sCoverImage1,
        pageTitle: 'Banking',
        content: "The current version of our product is built Banking & Financial Services industries. Supprt for Insurance, Government, Retail and Telecom are in our future roadmap."
    },
]